/**
 * Quite a lot of csv operations being used in the domain, if you find one not in this lib then
 * move it over and write / move its tests over too
 */ var ref;
export var parseCSV = function() {
    var csvString = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", delim = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ",";
    return (ref = csvString === null || csvString === void 0 ? void 0 : csvString.split(delim)) !== null && ref !== void 0 ? ref : [];
};
export var isCSV = function() {
    var csvString = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", delim = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ",";
    return (csvString === null || csvString === void 0 ? void 0 : csvString.includes(delim)) && typeof csvString === "string";
};
var ref1;
export var makeCSV = function() {
    var arrayString = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], delim = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ",";
    return (ref1 = arrayString === null || arrayString === void 0 ? void 0 : arrayString.join(delim)) !== null && ref1 !== void 0 ? ref1 : "";
};
export var mapCSV = function() {
    var csvString = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", mapFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function(str) {
        return str;
    }, delim = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",";
    return parseCSV(csvString, delim).map(function(element) {
        return mapFn(element);
    }).join(delim);
};
var _nth;
export var nthCSV = function() {
    var csvString = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", nth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, delim = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",";
    return (_nth = parseCSV(csvString, delim)[nth]) !== null && _nth !== void 0 ? _nth : "";
};
export var findInCSV = function() {
    var csvString = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", predicate = arguments.length > 1 ? arguments[1] : void 0, delim = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",";
    return parseCSV(csvString, delim).find(function(element) {
        return predicate(element);
    });
};
